import React, {useState} from "react";

const ContactForm = () => {
    const [formData, setFormData] = useState({
        FNAME: "",
        EMAIL: "",
        MMERGE2: ""
    });
    const [formErrors, setFormErrors] = useState("");

    function handleChange(event) {
        const { name, value } = event.target;

        setFormData((prev) => {
            return {
                ...prev,
                [name]: value
            }
        });
    }

    function handleSubmit(event) {
        event.preventDefault();

        let missingFields = [];
        if (!formData.FNAME.trim()) missingFields.push("Name");
        if (!formData.EMAIL.trim() || formData.EMAIL.trim().length < 5 || !formData.EMAIL.trim().includes("@")) missingFields.push("Email");
        if (!formData.MMERGE2.trim() || formData.MMERGE2.trim().length < 5) missingFields.push("Project Details");

        let missingFieldString = "";
        if (missingFields.length) {
            if (missingFields.length > 1) {
                const lastIndex = missingFields.length - 1;
                missingFields[lastIndex] = "and " + missingFields[lastIndex];
            }
            if (missingFields.length > 2) {
                missingFieldString = missingFields.join(", ");
            } else {
                missingFieldString = missingFields.join(" ");
            }
            setFormErrors(missingFieldString + " must be filled out.");
            return;
        }

        setFormErrors("");
        event.target.submit();
    }

    return (
        <section className="contact-form">
            <div className="container">
                <p className="section-title">Contact</p>

                <div id="mc_embed_signup">
                        <form
                            action="https://zoty.us4.list-manage.com/subscribe/post?u=2dc29d96b21031752bbb29526&amp;id=bf2d66b68a"
                            method="post"
                            id="mc-embedded-subscribe-form"
                            name="mc-embedded-subscribe-form"
                            className="validate"
                            target="_blank"
                            noValidate
                            autoComplete="off"
                            onSubmit={handleSubmit}>
                            <div id="mc_embed_signup_scroll">
                                    <div className="row mobile-column">
                                        <input
                                            type="text"
                                            placeholder="Name"
                                            name="FNAME"
                                            className="form-field required"
                                            id="mce-FNAME"
                                            onChange={handleChange}
                                            value={formData.FNAME}
                                            required />
                                        <input
                                            type="email"
                                            placeholder="Email"
                                            name="EMAIL"
                                            className="form-field required email"
                                            id="mce-EMAIL"
                                            onChange={handleChange}
                                            value={formData.EMAIL}
                                            required />
                                    </div>

                                    <textarea
                                        maxLength="500"
                                        rows="5"
                                        placeholder="Project details"
                                        name="MMERGE2"
                                        className="form-field"
                                        id="mce-MMERGE2"
                                        onChange={handleChange}
                                        value={formData.MMERGE2}
                                        required>
                                    </textarea>
                                </div>
                                <div id="mce-responses" className="clear">
                                    <div className="response" id="mce-error-response" style={{display: "none"}}></div>
                                    <div className="response" id="mce-success-response" style={{display: "none"}}></div>
                                </div>

                                <input type="hidden" name="b_2dc29d96b21031752bbb29526_bf2d66b68a" tabIndex="-1" defaultValue="" />
                                {formErrors !== "" && <p className="form-error"><b>Notice</b><br />{formErrors}</p>}
                                <button type="submit" name="subscribe" id="mc-embedded-subscribe" className="button-submit">Send It</button>
                        </form>
                    </div>
            </div>
        </section>
    );
}

export default ContactForm;